// var BASE_URL = process.env.DOCUMENT_BASE_URL
var BASE_URL = process.env.API_BASE_URL
export default {
  BASE_URL:   BASE_URL,
  // VERIFY_DOCUMENT_URL:   BASE_URL + 'pdfmaker/verifyPdf?apikey=VN8naeTJb9TXd0O2q5SrkGhnAA3oXgmn&referenceNo=',
  VERIFY_DOCUMENT_URL:   BASE_URL + 'certificate/viewRenderDoc?local=en&refernaceNo=',
  VERIFY_DOCUMENT: 'VERIFY_DOCUMENT',
}